import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import {
  Button, Copy01, DotsVertical, Edit01, Link01, Menu, Modal, RefreshCw01, Select, Spinner, Tabs, Tooltip,
} from '@opendate-app/setlist';

import TicketGroup from './TicketGroup';
import PassHolderLimitField from "./PassHolderLimitField";
import AddOnsTab from './AddOnsTab';
import PromoCodesTab from './PromoCodesTab';
import DeliveryTab from './DeliveryTab';
import MembershipsTab from './MembershipsTab';
import SettingsTab from './SettingsTab';
import Kills from './Kills';
import Holds from './Holds';
import GeneralAdmissionHolds from './GeneralAdmissionHolds';
import SeatingChartCard from './SeatingChartCard';
import TicketTypeDrawer from './TicketTypeDrawer';
import TicketPricePoints from './TicketPricePoints';
import { quantityPricePoint } from '../utils/ticketPricePoints';
import { canSubmitForm, manualTaxShouldBeChecked, parseFloatFromString, visiblePricePoints } from './ticketTypeFormHelpers';
import EditSeatingChartDesigner from './EditSeatingChartDesigner';
import SeatsInTheWayBanner from './SeatsInTheWayBanner';
import SaveAsTemplateModal from './SaveAsTemplateModal';
import { toastError } from '../../../shared/toastHelper';
import TicketDrawer from './TicketDrawer';
import OpendateDistributionTermsModal from './OpendateDistributionTermsModal';
import SeatMapSwapPricesModal from './SeatMapSwapPricesModal';
import MatchTemplateModal from './MatchTemplateModal';
import SectionOfferTiersModal from './SectionOfferTiersModal';
import SeatMapSwapPreviewModal from './SeatMapSwapPreviewModal';


var _ = require('lodash');
const axios = require('axios').default;
import { toast } from 'react-toastify';

import {
  TICKETING_ADMISSION_MENU_ITEM,
  TICKETING_PROMO_CODES_MENU_ITEM,
  TICKETING_KILLS_MENU_ITEM,
  TICKETING_HOLDS_MENU_ITEM,
  TICKETING_ADD_ONS_MENU_ITEM,
  TICKETING_DELIVERY_MENU_ITEM,
  TICKETING_MEMBERSHIPS_MENU_ITEM,
  TICKETING_SETTINGS_MENU_ITEM,
  AUTOMATION_MENU_ITEM,
  PROMOTION_MENU_ITEM
} from '../constants/confirmTicketingConstants';

import { ticketTypeParams } from '../actions/confirmTicketingActionCreators';

var debouncedDetermineFinalCosts;

const helpTextStyle = { color: "var(--sl-text-tertiary)", fontSize: "14px" };






export { timeOnDate } from './ticketTypeFormHelpers';

const canChangeTicketingArrangement = (confirm, isLoadingDefaultTicketTypes) => {
  return (
    confirm
      && confirm.can_change_ticketing_arrangement
      && !isLoadingDefaultTicketTypes
  )
}

const canEditSeatingChart = (seatingChart) => {
  return (
    seatingChart && !seatingChart.legacy && !seatingChart.template_chart
  )
}

const reasonWeCannotEditSeatingChart = (seatingChart) => {
  if (!seatingChart) {
    return "This seating chart is a template and cannot be edited. Please select a new chart if you would like to make edits.";
  }

  if (seatingChart.legacy) {
    return "This is chart belongs to a legacy confirm and cannot be edited.";
  }

  
}





const Tickets = ({
  csrfToken,
  team,
  currentUser,
  confirm,
  activeMenuItemChanged,
  activeTicketingMenuItem,
  activeTicketingMenuItemChanged,
  ticketTypeForForm,
  ticketTypeForFormChanged,
  fetchNewTicketType,
  ticketTypes,
  fetchTicketTypeForEdit,
  addOns,
  addOnForForm,
  fetchNewAddOn,
  addOnForFormChanged,
  createAddOn,
  fetchAddOnToEdit,
  deleteAddOn,
  updateAddOn,
  addOnDragged,
  exampleTicket,
  buildExampleTicket,
  exampleTicketChanged,
  seatingCharts,
  seatsIOPublicKey,
  autoSaveConfirm,
  updateConfirm,
  isLoadingDefaultTicketTypes,
  addOnSeatingCharts,
  isEditingAddOnsIntro,
  isEditingAddOnsIntroChanged,
  addOnsIntroEditorState,
  addOnsIntroEditorStateChanged,
  isLoadingDefaultAddOns,
  isEditingAddOnsAlertMessage,
  isEditingAddOnsAlertMessageChanged,
  addOnsAlertMessageEditorState,
  addOnsAlertMessageEditorStateChanged,
  showActivities,
  manualTaxes,
  addOnAdded,
  feeRuleSets,
  preSaleEnabled,
  confirmChanged,
  seatingChartEvents,
  rootTicketGroup,
  ticketGroupChanged,
  ticketTypesChanged,
  isLoadingDefaultTicketTypesChanged,
  ticketTypeIsSeated,
  reloadTicketTypes,
  reloadAddOns,
  isLoadingDefaultAddOnsChanged,
  admissionSeatingChartEvent,
  admissionSeatingChartEventChanged,
  addOnSeatingChartEvent,
  addOnSeatingChartEventChanged,
  seatingChartEventsChanged,
  holds,
  fetchHolds,
  createHold,
  updateHold,
  deleteHold,
  generalAdmissionHolds,
  fetchGeneralAdmissionHolds,
  createGeneralAdmissionHold,
  updateGeneralAdmissionHold,
  deleteGeneralAdmissionHold,
  kills,
  fetchKills,
  createKill,
  updateKill,
  deleteKill,
  addOnsIntroTemplates,
  addOnsAlertMessageTemplates,
  addOnsIntroTemplateDraft,
  addOnsAlertMessageTemplateDraft,
  addOnMessageTemplateChanged,
  createAddOnMessageTemplate,
  deleteAddOnMessageTemplate
}) => {
  const fairMarketValueEnabled = Boolean(team?.can_access_fair_market_value);
  const [showDesigner, setShowDesigner] = useState(false);
  const [designerStartsWithPanel, setDesignerStartsWithPanel] = useState(false);
  const [seatsInTheWaySince, setSeatsInTheWaySince] = useState(undefined);
  useEffect(() => { setSeatsInTheWaySince(undefined); }, [admissionSeatingChartEvent]);
  const [showSaveTemplate, setShowSaveTemplate] = useState(false);
  const [showMatchTemplate, setShowMatchTemplate] = useState(false);
  const [showOfferTiers, setShowOfferTiers] = useState(false);
  const [overCapacity, setOverCapacity] = useState(null);
  const [raisingCapacity, setRaisingCapacity] = useState(false);
  const drawerSession = useRef(0);
  const raisingCapacityNow = useRef(false);
  const ticketFormOpen = Object.keys(ticketTypeForForm).length > 0;
  const [showDistributionTermsModal, setShowDistributionTermsModal] = useState(false);
  const [distributionTermsAccepted, setDistributionTermsAccepted] = useState(false);
  const [agreeingToTerms, setAgreeingToTerms] = useState(false);

  const selectedAdmissionChartId = admissionSeatingChartEvent?.seating_chart_id;
  const admissionChartExists = seatingCharts.some((sc) => sc.id === selectedAdmissionChartId);
  const admissionArchivedSelected = !!selectedAdmissionChartId && !admissionChartExists;
  const seatMapPicked = confirm.ticketing_arrangement === "Seated" && Boolean(selectedAdmissionChartId);
  const hasOffSeatMapTickets = (ticketTypes || []).some((ticketType) => !ticketTypeIsSeated(ticketType));
  const hasTicketGroup = (rootTicketGroup.sub_groups || []).some((subGroup) => !subGroup.presale_pool && !subGroup.pass_holder_pool);

  const onSelectSeatingChart = async (seatingChart) => {
    if (!canChangeTicketingArrangement(confirm, isLoadingDefaultTicketTypes)) {
      if (admissionSeatingChartEvent?.id && !isLoadingDefaultTicketTypes) {
        await showSwapPreview(seatingChart);
      }
      return;
    }
    if (admissionSeatingChartEvent?.id) {
      setSeatingChartToSwapTo(seatingChart);
      return;
    }

    await saveSeatingChart(seatingChart, true);
  };

  const showSwapPreview = async (seatingChart) => {
    setSwapPreviewLoading(true);
    try {
      const response = await axios.get(
        `/teams/${team.id}/calendar_events/${confirm.id}/seating_chart_events/${admissionSeatingChartEvent.id}/swap_preview`,
        { params: { seating_chart_id: seatingChart.id } }
      );
      const mapName = seatingCharts.find((chart) => String(chart.id) === String(seatingChart.id))?.name;
      setSwapPreview({ ...response.data, map_name: mapName, seating_chart: seatingChart });
    } catch (error) {
      toastError("Couldn't check which seats carry over to that seat map");
    } finally {
      setSwapPreviewLoading(false);
    }
  };

  const saveSeatingChart = async (seatingChart, keepPrices) => {
    isLoadingDefaultTicketTypesChanged(true);

    const params = {
      seating_chart_event: {
        seating_chart_id: seatingChart.id,
        context: "admission",
        keep_prices: keepPrices
      }
    };

    try {
      const response = admissionSeatingChartEvent?.id ?
        await axios.patch(`/teams/${team.id}/calendar_events/${confirm.id}/seating_chart_events/${admissionSeatingChartEvent.id}`, params) :
        await axios.post(`/teams/${team.id}/calendar_events/${confirm.id}/seating_chart_events`, params);

      reloadTicketTypes();

      
      admissionSeatingChartEventChanged(response.data.seating_chart_event);
    } catch (error) {
      isLoadingDefaultTicketTypesChanged(false);
      toastError(error.response?.data?.errors?.base?.[0] || "Failed to update seating chart");
    }
  };

  const [confirmingGeneralAdmission, setConfirmingGeneralAdmission] = useState(false);

  const selectGeneralAdmission = async () => {
    if (!canChangeTicketingArrangement(confirm, isLoadingDefaultTicketTypes)) {
      return;
    }

    isLoadingDefaultTicketTypesChanged(true);

    const updated = {
      ...confirm,
      ticketing_arrangement: "General Admission"
    };

    updateConfirm(updated);
    admissionSeatingChartEventChanged(null);

    autoSaveConfirm(csrfToken, team, updated, false, () => {
      reloadTicketTypes();
    });
  };



  const selectSeated = () => {
    if (!canChangeTicketingArrangement(confirm, isLoadingDefaultTicketTypes)) {
      return;
    }

    isLoadingDefaultTicketTypesChanged(true);

    const updated = {
      ...confirm,
      ticketing_arrangement: "Seated"
    };

    updateConfirm(updated);

    autoSaveConfirm(csrfToken, team, updated, false, () => {
      reloadTicketTypes();
    });
  };

  const latestTicketTypeForForm = useRef(ticketTypeForForm);
  latestTicketTypeForForm.current = ticketTypeForForm;
  const formSession = useRef({ id: ticketTypeForForm.id, open: false, version: 0 });
  const formOpen = Object.keys(ticketTypeForForm).length > 0;
  if (formSession.current.id !== ticketTypeForForm.id || formSession.current.open !== formOpen) {
    formSession.current = { id: ticketTypeForForm.id, open: formOpen, version: formSession.current.version + 1 };
  }
  const previewRequest = useRef(0);

  const [pricePointToRemove, setPricePointToRemove] = useState(null);
  const [seatingChartToSwapTo, setSeatingChartToSwapTo] = useState(null);
  const [swapPreview, setSwapPreview] = useState(null);
  const [swapPreviewLoading, setSwapPreviewLoading] = useState(false);
  const ticketDrawerClosesOnEsc = !showDistributionTermsModal && pricePointToRemove === null;

  const determineFinalCosts = (ticket, sessionVersion) => {
    if (sessionVersion !== formSession.current.version || !formSession.current.open) return;
    const request = ++previewRequest.current;
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    const normalParams = ticketTypeParams(ticket, confirm);

    const taxableItemsAttrs = (normalParams.taxable_items_attributes || []).map((taxableItem) => {
      return {...taxableItem, id: ""};
    });

    var params = {
      ticket_types: [
        {
          price: normalParams.price || 0.0,
          free: normalParams.free,
          has_fixed_fees: normalParams.has_fixed_fees,
          fixed_fee_amount: normalParams.fixed_fee_amount,
          absorb_fees: normalParams.absorb_fees,
          round_up: normalParams.round_up,
          calendar_event_id: normalParams.calendar_event_id,
          taxable_items_attributes: taxableItemsAttrs
        }
      ]
    }

    visiblePricePoints(ticket.price_points).forEach((pricePoint) => {
      params["ticket_types"].push({
        free: normalParams.free,
        has_fixed_fees: normalParams.has_fixed_fees,
        fixed_fee_amount: normalParams.fixed_fee_amount,
        absorb_fees: normalParams.absorb_fees,
        round_up: normalParams.round_up,
        calendar_event_id: normalParams.calendar_event_id,
        taxable_items_attributes: taxableItemsAttrs,
        price: pricePoint.price_two_decimals ? parseFloatFromString(pricePoint.price_two_decimals) : 0.0
      });
    });

    return axios.post("/teams/" + team.id + "/ticket_types/build_ticket", {
      ticket_type: params
    })
      .then(({ data }) => {
        if (sessionVersion !== formSession.current.version || request !== previewRequest.current) return;
        const card = data.card;
        const cash = data.cash;
        const latest = latestTicketTypeForForm.current;
        const currentTicket = latest && latest.id === ticket.id ? latest : ticket;
        const pricedPoints = visiblePricePoints(ticket.price_points);

        ticketTypeForFormChanged({
          ...currentTicket,
          final_cost: card[0]?.final_cost || 0,
          custom_charges: card[0]?.custom_charges || 0,
          fees: card[0]?.fees || 0,
          organizer_service_fee: card[0]?.organizer_service_fee || 0,
          round_up_organizer_fee: card[0]?.round_up_organizer_fee || 0,
          opendate_service_fee: card[0]?.opendate_service_fee || 0,
          processing_fee: card[0]?.processing_fee || 0,
          rebate_fee: card[0]?.rebate_fee || 0,
          taxes: card[0]?.taxes || 0,
          cash_final_cost: cash[0]?.final_cost || 0,
          cash_custom_charges: cash[0]?.custom_charges || 0,
          cash_fees: cash[0]?.fees || 0,
          cash_organizer_service_fee: cash[0]?.organizer_service_fee || 0,
          cash_round_up_organizer_fee: cash[0]?.round_up_organizer_fee || 0,
          cash_opendate_service_fee: cash[0]?.opendate_service_fee || 0,
          cash_processing_fee: cash[0]?.processing_fee || 0,
          cash_rebate_fee: cash[0]?.rebate_fee || 0,
          cash_taxes: cash[0]?.taxes || 0,
          price_points: (currentTicket.price_points || []).map((pricePoint) => {
            const index = pricedPoints.findIndex((pricedPoint) => pricedPoint.id === pricePoint.id);
            if (index === -1 || pricePoint._destroy) return pricePoint;

            return {
              ...pricePoint,
              absorb_fees: ticket.absorb_fees,
              round_up: ticket.round_up,
              final_cost: card[index + 1]?.final_cost || 0,
              custom_charges: card[index + 1]?.custom_charges || 0,
              fees: card[index + 1]?.fees || 0,
              organizer_service_fee: card[index + 1]?.organizer_service_fee || 0,
              round_up_organizer_fee: card[index + 1]?.round_up_organizer_fee || 0,
              opendate_service_fee: card[index + 1]?.opendate_service_fee || 0,
              processing_fee: card[index + 1]?.processing_fee || 0,
              rebate_fee: card[index + 1]?.rebate_fee || 0,
              taxes: card[index + 1]?.taxes || 0,
              cash_final_cost: cash[index + 1]?.final_cost || 0,
              cash_custom_charges: cash[index + 1]?.custom_charges || 0,
              cash_fees: cash[index + 1]?.fees || 0,
              cash_organizer_service_fee: cash[index + 1]?.organizer_service_fee || 0,
              cash_round_up_organizer_fee: cash[index + 1]?.round_up_organizer_fee || 0,
              cash_opendate_service_fee: cash[index + 1]?.opendate_service_fee,
              cash_processing_fee: cash[index + 1]?.processing_fee || 0,
              cash_rebate_fee: cash[index + 1]?.rebate_fee || 0,
              cash_taxes: cash[index + 1]?.taxes || 0,
            };
          })
        });
      })
      .catch((error) => {
        toast.error("Failed to calculate ticket costs", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };

  const startShowActivity = showActivities.find(showActivity => {
    return showActivity.id === ticketTypeForForm.start_show_activity_id
  })

  const endShowActivity = showActivities.find(showActivity => {
    return showActivity.id === ticketTypeForForm.end_show_activity_id
  })

  const waitForTicketType = ticketTypes.find(ticketType => {
    return ticketType.id === ticketTypeForForm.wait_for_ticket_type_id
  });

  const useDateAndTime = ticketTypeForForm.availability === "Date & Time"
  const useShowDetails = ticketTypeForForm.availability === "Based on show details"

  const eventChartClone = admissionSeatingChartEvent?.event_chart_clone;
  const pendingSince = seatsInTheWaySince === undefined ? eventChartClone?.seats_in_the_way_since : seatsInTheWaySince;
  const openDesigner = (withPanel) => { setDesignerStartsWithPanel(withPanel); setShowDesigner(true); };

  const enablePricePoints = !ticketTypeForForm.free && (useDateAndTime || useShowDetails);

  const pricePointsMinDate = useDateAndTime
    ? ticketTypeForForm.start_time
    : useShowDetails
      ? startShowActivity?.start_time
      : null

  const pricePointsMaxDate = useDateAndTime || !useShowDetails
    ? ticketTypeForForm.end_time
    : endShowActivity?.start_time

  const newPricePoint = (trigger) => {
    const useQuantity = trigger === 'quantity' || visiblePricePoints(ticketTypeForForm.price_points).some(quantityPricePoint);
    ticketTypeForFormChanged({
      ...ticketTypeForForm,
      price_points: [
        ...(ticketTypeForForm.price_points || []),
        {
          id: Date.now() + Math.random(),
          newRecord: true,
          starts_at: useQuantity ? null : '',
          sold_count_threshold: useQuantity ? '' : null,
          price_two_decimals: ""
        }
      ]
    })
  }

  useEffect(() => {
    drawerSession.current += 1;
    raisingCapacityNow.current = false;
    setRaisingCapacity(false);
    setOverCapacity(null);
  }, [ticketFormOpen, ticketTypeForForm.id]);

  const saveTicketTypeRequest = (request, raiseCapacity) => {
    const save = drawerSession.current;
    if (raisingCapacityNow.current) {
      return Promise.resolve();
    }
    if (raiseCapacity) {
      raisingCapacityNow.current = true;
      setRaisingCapacity(true);
    }

    return request(() => save === drawerSession.current)
      .catch((error) => showSaveError(error, save !== drawerSession.current))
      .finally(() => {
        if (raiseCapacity && save === drawerSession.current) {
          raisingCapacityNow.current = false;
          setRaisingCapacity(false);
        }
      });
  };

  const showSaveError = (error, drawerMovedOn) => {
    const data = error.response?.data;
    if (data?.over_capacity !== undefined && !drawerMovedOn) {
      setOverCapacity(data.over_capacity);
      return;
    }

    const messages = data?.over_capacity !== undefined ? [`That ticket wasn't saved: it would put the show over its capacity of ${data.over_capacity}.`] : data;
    toast.error(Array.isArray(messages) ? messages.join(", ") : "Something went wrong saving this ticket. Please try again.", {
      position: toast.POSITION.TOP_CENTER,
      draggable: false,
      closeOnClick: false,
      autoClose: 5000,
      hideProgressBar: true
    });
  };

  const createTicketType = (csrfToken, team, confirm, ticketType, raiseCapacity = false) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return saveTicketTypeRequest((stillOpen) => axios.post("/teams/" + team.id + "/ticket_types", {
        ticket_type: { ...ticketTypeParams(ticketType, confirm), ...(raiseCapacity && { raise_room_capacity: true }) }
      })
      .then(({ data }) => {
        if (stillOpen()) {
          setOverCapacity(null);
          ticketTypeForFormChanged({});
        }
        if (data.root_ticket_group) {
          ticketGroupChanged(data.root_ticket_group);
          return;
        }

        var ticketGroup = ticketType.ticketGroup;
        var updated = Object.assign({}, ticketGroup, {
          ticket_types: [
            ...ticketGroup.ticket_types,
            data
          ]
        });

        ticketGroupChanged(updated);
      }), raiseCapacity);
  };

  const updateTicketType = (csrfToken, team, ticketType, raiseCapacity = false) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return saveTicketTypeRequest((stillOpen) => axios.patch("/teams/" + team.id + "/ticket_types/" + ticketType.id, {
        ticket_type: { ...ticketTypeParams(ticketType), ...(raiseCapacity && { raise_room_capacity: true }) }
      })
      .then(({ data }) => {
        if (stillOpen()) {
          setOverCapacity(null);
          ticketTypeForFormChanged({});
        }
        if (data.root_ticket_group) {
          ticketGroupChanged(data.root_ticket_group);
          return;
        }

        var ticketGroup = ticketType.ticketGroup;
        var updated = Object.assign({}, ticketGroup, {
          ticket_types: ticketGroup.ticket_types.map((ticketType) => {
            return ticketType.id === data.id ? data : ticketType;
          })
        });

        ticketGroupChanged(updated);
      }), raiseCapacity);
  };

  useEffect(() => {
    debouncedDetermineFinalCosts = _.debounce((ticket, sessionVersion) => {
      determineFinalCosts(ticket, sessionVersion);
    }, 500);
    return () => {
      debouncedDetermineFinalCosts.cancel();
      formSession.current.version += 1;
    };
  }, []);

  const scheduleFinalCosts = (ticket) => debouncedDetermineFinalCosts(ticket, formSession.current.version);

  const arrangementChangeable = Boolean(canChangeTicketingArrangement(confirm, isLoadingDefaultTicketTypes));

  const ticketingSubtabs = [
    { value: TICKETING_ADMISSION_MENU_ITEM, label: "Admission" },
    { value: TICKETING_ADD_ONS_MENU_ITEM, label: "Add-ons" },
    { value: TICKETING_HOLDS_MENU_ITEM, label: "Holds" },
    { value: TICKETING_KILLS_MENU_ITEM, label: "Kills" },
    { value: TICKETING_PROMO_CODES_MENU_ITEM, label: "Promo Codes" },
    { value: TICKETING_DELIVERY_MENU_ITEM, label: "Delivery" },
    ...(team.can_access_memberships ? [{ value: TICKETING_MEMBERSHIPS_MENU_ITEM, label: "Memberships" }] : []),
    { value: TICKETING_SETTINGS_MENU_ITEM, label: "Settings" }
  ];

  const seatingChartOptions = [
    ...(admissionArchivedSelected ? [{
      value: selectedAdmissionChartId,
      label: `Archived: ${admissionSeatingChartEvent?.seating_chart_name || `Chart #${selectedAdmissionChartId}`}`,
      disabled: true
    }] : []),
    ...seatingCharts.map((seatingChart) => ({ value: seatingChart.id, label: seatingChart.name }))
  ];

  return (
    <React.Fragment>
      {
        canEditSeatingChart(eventChartClone) &&

        <EditSeatingChartDesigner
          show={showDesigner}
          onClose={() => setShowDesigner(false)}
          seatingChart={eventChartClone}
          onChartSynced={() => { setSeatsInTheWaySince(null); reloadTicketTypes(); }}
          onRefused={() => setSeatsInTheWaySince(pendingSince || new Date().toISOString())}
          onDiscarded={() => setSeatsInTheWaySince(null)}
          startWithPanel={designerStartsWithPanel}
          hasPendingDraft={Boolean(pendingSince)}
          readOnlyName={true}
        />
      }
      {
        eventChartClone && canEditSeatingChart(eventChartClone) &&

        <SaveAsTemplateModal
          open={showSaveTemplate}
          onClose={() => setShowSaveTemplate(false)}
          seatingChart={eventChartClone}
          context="admission"
          csrfToken={csrfToken}
        />
      }
      {
        canEditSeatingChart(eventChartClone) &&

        <MatchTemplateModal
          open={showMatchTemplate}
          url={`/teams/${team.id}/calendar_events/${confirm.id}/seating_chart_events/${admissionSeatingChartEvent.id}/match_template`}
          csrfToken={csrfToken}
          onClose={() => setShowMatchTemplate(false)}
          onMatched={(seatingChartEvent) => {
            setShowMatchTemplate(false);
            admissionSeatingChartEventChanged(seatingChartEvent);
            reloadTicketTypes();
            toast.success("This show now matches its template.");
          }}
        />
      }
      {
        canEditSeatingChart(eventChartClone) &&

        <SectionOfferTiersModal
          open={showOfferTiers}
          url={`/teams/${team.id}/calendar_events/${confirm.id}/section_offer_tiers`}
          csrfToken={csrfToken}
          onClose={() => setShowOfferTiers(false)}
          onSaved={() => {
            setShowOfferTiers(false);
            reloadTicketTypes();
          }}
        />
      }
      <div className="row">
        <div className="col-12">
          <h3 style={{"fontSize": "20px"}}
              className="mb-3">
            <strong>
              Tickets
            </strong>
          </h3>
          <Tabs
            aria-label="Ticketing sections"
            items={ticketingSubtabs}
            value={activeTicketingMenuItem}
            onChange={activeTicketingMenuItemChanged}
          />
          {(activeTicketingMenuItem === TICKETING_ADMISSION_MENU_ITEM ? (
            <React.Fragment>
              {pendingSince && canEditSeatingChart(eventChartClone) && !showDesigner ? (
                <div className="mt-4">
                  <SeatsInTheWayBanner
                    key={pendingSince}
                    seatingChart={eventChartClone}
                    onMoveFans={() => openDesigner(true)}
                    onOpenMap={() => openDesigner(false)}
                    onSaved={() => { setSeatsInTheWaySince(null); reloadTicketTypes(); }}
                  />
                </div>
              ) : null}
              <div className="row mt-4">
                <div className="col">
                  {seatingCharts.length > 0 ? (
                    <>
                    <Modal
                      open={confirmingGeneralAdmission}
                      onClose={() => setConfirmingGeneralAdmission(false)}
                      type="warning"
                      role="alertdialog"
                      width={440}
                      title="Switch to general admission?"
                      description="This removes the seat map and its seated tickets, prices, add-ons, holds and kills. You'll need to pick a map again."
                      footer={(
                        <>
                          <Button variant="secondary" autoFocus onClick={() => setConfirmingGeneralAdmission(false)}>Cancel</Button>
                          <Button variant="primary" onClick={() => { setConfirmingGeneralAdmission(false); selectGeneralAdmission(); }}>Switch to general admission</Button>
                        </>
                      )}
                    />
                    <Tabs
                      variant="button-border"
                      size="sm"
                      collapseBelow={0}
                      aria-label="Ticketing arrangement"
                      items={[
                        { value: "Seated", label: "Seated", disabled: !arrangementChangeable },
                        { value: "General Admission", label: "General Admission", disabled: !arrangementChangeable }
                      ]}
                      value={confirm.ticketing_arrangement}
                      onChange={(arrangement) => {
                        if (arrangement === "Seated") return selectSeated();
                        if (confirm.ticketing_arrangement === "Seated" && admissionSeatingChartEvent?.seating_chart_id) return setConfirmingGeneralAdmission(true);
                        return selectGeneralAdmission();
                      }}
                    />
                    </>
                  ) : null}
                </div>
                {confirm.ticketing_arrangement === "Seated" && admissionSeatingChartEvent?.seating_chart_id ? (
                  <div className="col d-flex justify-content-end align-items-center"
                       style={{"paddingRight": "15px", "gap": "8px"}}>
                    {seatingCharts.length > 1 ? (
                    <Select
                      size="sm"
                      width={200}
                      aria-label="Seating chart"
                      disabled={Boolean(isLoadingDefaultTicketTypes) || swapPreviewLoading}
                      options={seatingChartOptions}
                      value={selectedAdmissionChartId}
                      onChange={(seatingChartId) => onSelectSeatingChart({ id: seatingChartId })}
                    />
                    ) : null}
                    {swapPreviewLoading ? <Spinner size="sm" aria-label="Checking seats" /> : null}
                    {canEditSeatingChart(eventChartClone) ? (
                      <Menu
                        placement="bottom-end"
                        trigger={
                          <Button variant="tertiary" size="sm" icon={DotsVertical} aria-label="Seating chart actions" />
                        }
                        items={[
                          { label: "Edit Seating Chart", icon: Edit01, onClick: () => openDesigner(false) },
                          { label: "Save as venue template", icon: Copy01, onClick: () => setShowSaveTemplate(true) },
                          { label: "Link offer tiers", icon: Link01, onClick: () => setShowOfferTiers(true) },
                          ...(eventChartClone.diverged_from_template ? [{ label: "Match template again", icon: RefreshCw01, onClick: () => setShowMatchTemplate(true) }] : [])
                        ]}
                      />
                    ) : (
                      <Tooltip title={reasonWeCannotEditSeatingChart(eventChartClone)}>
                        <span tabIndex={0}>
                          <Button variant="tertiary" size="sm" icon={DotsVertical} aria-label="Seating chart actions" disabled />
                        </span>
                      </Tooltip>
                    )}
                  </div>
                ) : null}
              </div>
              {seatingCharts.length > 0 ? (
                <div className="row">
                  <div className="col-12 mt-3">
                    {confirm.ticketing_arrangement === "Seated" && !admissionSeatingChartEvent?.seating_chart_id ? (
                      <p className="mb-0" style={helpTextStyle}>
                        Select your seating configuration.
                      </p>
                    ) : confirm.ticketing_arrangement === "Seated" && admissionSeatingChartEvent?.seating_chart_id ? (
                      <p className="mb-0" style={helpTextStyle}>
                        Seat map tickets are defined by your seating configuration. You can modify their pricing, or add tickets that aren't on the seat map.
                      </p>
                    ) : (
                      <p className="mb-0" style={helpTextStyle}>
                        Create your tickets.
                      </p>
                    )}
                  </div>
                </div>
              ) : null}
              {isLoadingDefaultTicketTypes ? (
                <div className="form-row mt-3">
                  <div className="col-12 text-center">
                    <Spinner size="lg" />
                  </div>
                </div>
              ) : seatingCharts.length > 0 && confirm.ticketing_arrangement === "Seated" && !admissionSeatingChartEvent?.seating_chart_id ? (
                <div className="form-row" style={{"marginTop": "14px"}}>
                  {seatingCharts.map((seatingChart, index) =>
                    <SeatingChartCard
                      key={index}
                      seatingChart={seatingChart}
                      csrfToken={csrfToken}
                      isAddOn={false}
                      onSelectChart={onSelectSeatingChart}
                    />
                  )}
                </div>
              ) : (
                <div style={{"marginTop": "15px"}}>
                  <TicketGroup csrfToken={csrfToken}
                                team={team}
                                currentUser={currentUser}
                                fetchNewTicketType={fetchNewTicketType}
                                fetchTicketTypeForEdit={fetchTicketTypeForEdit}
                                ticketTypeIsSeated={ticketTypeIsSeated}
                                confirm={confirm}
                                depth={0}
                                ticketGroupChanged={ticketGroupChanged}
                                ticketTypesChanged={ticketTypesChanged}
                                parentTicketGroup={null}
                                updateConfirm={updateConfirm}
                                provided={{}}
                                snapshot={{}}
                                canAddSubGroup={confirm.ticketing_arrangement !== "Seated"}
                                showHeader={confirm.ticketing_arrangement !== "Seated"}
                                showSubGroupHeaders={seatMapPicked}
                                rootTicketGroup={rootTicketGroup}
                                redesignEnabled={team.can_access_ticketing_setup_redesign}
                                ticketGroup={rootTicketGroup} />
                  {seatMapPicked && !hasTicketGroup ? (
                    <div className="mt-3">
                      <Button variant="secondary-color"
                              onClick={() => fetchNewTicketType(csrfToken, team, confirm, rootTicketGroup, null)}>
                        Add Ticket
                      </Button>
                    </div>
                  ) : null}
                  <PassHolderLimitField csrfToken={csrfToken}
                                        team={team}
                                        confirm={confirm}
                                        confirmChanged={confirmChanged}
                                        ticketGroupChanged={ticketGroupChanged} />
                </div>
              )}
            </React.Fragment>
          ) : activeTicketingMenuItem === TICKETING_HOLDS_MENU_ITEM ? (
            confirm.ticketing_arrangement === "General Admission" ? (
              <GeneralAdmissionHolds
                csrfToken={csrfToken}
                confirm={confirm}
                ticketTypes={ticketTypes}
                addOns={addOns}
                generalAdmissionHolds={generalAdmissionHolds}
                fetchGeneralAdmissionHolds={fetchGeneralAdmissionHolds}
                createGeneralAdmissionHold={createGeneralAdmissionHold}
                updateGeneralAdmissionHold={updateGeneralAdmissionHold}
                deleteGeneralAdmissionHold={deleteGeneralAdmissionHold}
                reloadTicketTypes={reloadTicketTypes}
              />
            ) : (
              <React.Fragment>
                <Holds
                  csrfToken={csrfToken}
                  admissionSeatingChartEvent={admissionSeatingChartEvent}
                  addOnSeatingChartEvent={addOnSeatingChartEvent}
                  seatingChartEvents={seatingChartEvents}
                  holds={holds || []}
                  fetchHolds={fetchHolds}
                  createHold={createHold}
                  updateHold={updateHold}
                  deleteHold={deleteHold}
                  seatsIOPublicKey={seatsIOPublicKey}
                  seatChannels={[...(holds || []).map(hold => hold.seatsio_channel_key).filter(Boolean), 'NO_CHANNEL']}
                  reloadTicketTypes={reloadTicketTypes}
                  reloadAddOns={reloadAddOns}
                />
                {seatMapPicked && hasOffSeatMapTickets ? (
                  <GeneralAdmissionHolds
                    title="General Admission Holds"
                    description="Hold tickets that aren't on the seat map."
                    csrfToken={csrfToken}
                    confirm={confirm}
                    ticketTypes={ticketTypes}
                    generalAdmissionHolds={generalAdmissionHolds}
                    fetchGeneralAdmissionHolds={fetchGeneralAdmissionHolds}
                    createGeneralAdmissionHold={createGeneralAdmissionHold}
                    updateGeneralAdmissionHold={updateGeneralAdmissionHold}
                    deleteGeneralAdmissionHold={deleteGeneralAdmissionHold}
                    reloadTicketTypes={reloadTicketTypes}
                  />
                ) : null}
              </React.Fragment>
            )
          ) : activeTicketingMenuItem === TICKETING_KILLS_MENU_ITEM ? (
            <Kills
              csrfToken={csrfToken}
              admissionSeatingChartEvent={admissionSeatingChartEvent}
              addOnSeatingChartEvent={addOnSeatingChartEvent}
              seatingChartEvents={seatingChartEvents}
              kills={kills || []}
              fetchKills={fetchKills}
              createKill={createKill}
              updateKill={updateKill}
              deleteKill={deleteKill}
              reloadTicketTypes={reloadTicketTypes}
              reloadAddOns={reloadAddOns}
            />
          ) : activeTicketingMenuItem === TICKETING_ADD_ONS_MENU_ITEM ? (
            <AddOnsTab csrfToken={csrfToken}
                       confirm={confirm}
                       currentUser={currentUser}
                       addOns={addOns}
                       addOnForForm={addOnForForm}
                       fetchNewAddOn={fetchNewAddOn}
                       addOnForFormChanged={addOnForFormChanged}
                       createAddOn={createAddOn}
                       fetchAddOnToEdit={fetchAddOnToEdit}
                       deleteAddOn={deleteAddOn}
                       updateAddOn={updateAddOn}
                       addOnDragged={addOnDragged}
                       addOnSeatingCharts={addOnSeatingCharts}
                       autoSaveConfirm={autoSaveConfirm}
                       updateConfirm={updateConfirm}
                       ticketTypes={ticketTypes}
                       isEditingAddOnsIntro={isEditingAddOnsIntro}
                       isEditingAddOnsIntroChanged={isEditingAddOnsIntroChanged}
                       addOnsIntroEditorState={addOnsIntroEditorState}
                       addOnsIntroEditorStateChanged={addOnsIntroEditorStateChanged}
                       isLoadingDefaultAddOns={isLoadingDefaultAddOns}
                       isEditingAddOnsAlertMessage={isEditingAddOnsAlertMessage}
                       isEditingAddOnsAlertMessageChanged={isEditingAddOnsAlertMessageChanged}
                       addOnsAlertMessageEditorState={addOnsAlertMessageEditorState}
                       addOnsAlertMessageEditorStateChanged={addOnsAlertMessageEditorStateChanged}
                       team={team}
                       manualTaxes={manualTaxes}
                       manualTaxShouldBeChecked={manualTaxShouldBeChecked}
                       addOnAdded={addOnAdded}
                       seatingChartEvents={seatingChartEvents}
                       showActivities={showActivities}
                       reloadAddOns={reloadAddOns}
                       isLoadingDefaultAddOnsChanged={isLoadingDefaultAddOnsChanged}
                       confirmChanged={confirmChanged}
                       addOnSeatingChartEvent={addOnSeatingChartEvent}
                       addOnSeatingChartEventChanged={addOnSeatingChartEventChanged}
                       seatingChartEventsChanged={seatingChartEventsChanged}
                       canEditSeatingChart={canEditSeatingChart}
                       reasonWeCannotEditSeatingChart={reasonWeCannotEditSeatingChart}
                       addOnsIntroTemplates={addOnsIntroTemplates}
                       addOnsAlertMessageTemplates={addOnsAlertMessageTemplates}
                       addOnsIntroTemplateDraft={addOnsIntroTemplateDraft}
                       addOnsAlertMessageTemplateDraft={addOnsAlertMessageTemplateDraft}
                       addOnMessageTemplateChanged={addOnMessageTemplateChanged}
                       createAddOnMessageTemplate={createAddOnMessageTemplate}
                       deleteAddOnMessageTemplate={deleteAddOnMessageTemplate} />
          ) : activeTicketingMenuItem === TICKETING_PROMO_CODES_MENU_ITEM ? (
            <PromoCodesTab csrfToken={csrfToken}
                           currentUser={currentUser}
                           confirm={confirm}
                           showActivities={showActivities}
                           team={team}
                           ticketTypes={ticketTypes}
                           holds={holds}
                           fetchHolds={fetchHolds}
                           generalAdmissionHolds={generalAdmissionHolds}
                           fetchGeneralAdmissionHolds={fetchGeneralAdmissionHolds} />
          ) : activeTicketingMenuItem === TICKETING_DELIVERY_MENU_ITEM ? (
            <DeliveryTab csrfToken={csrfToken}
                         team={team}
                         confirm={confirm}
                         updateConfirm={updateConfirm}
                         autoSaveConfirm={autoSaveConfirm} />
          ) : activeTicketingMenuItem === TICKETING_MEMBERSHIPS_MENU_ITEM ? (
            <MembershipsTab csrfToken={csrfToken}
                            team={team}
                            confirm={confirm}
                            ticketTypes={ticketTypes}
                            addOns={addOns} />
          ) : (
            <SettingsTab csrfToken={csrfToken}
                         confirm={confirm}
                         updateConfirm={updateConfirm}
                         autoSaveConfirm={autoSaveConfirm}
                         feeRuleSets={feeRuleSets}
                         confirmChanged={confirmChanged}
                         team ={team} />
          ))}
          <div className="row">
            <div className="col-12 d-flex justify-content-end align-items-end"
                 style={{"height": "130px"}}>
              <Button
                 variant="primary"
                 onClick={
                   () => {
                      if(activeTicketingMenuItem === TICKETING_ADMISSION_MENU_ITEM){
                        activeTicketingMenuItemChanged(TICKETING_ADD_ONS_MENU_ITEM);
                      } else if (activeTicketingMenuItem === TICKETING_ADD_ONS_MENU_ITEM) {
                        activeTicketingMenuItemChanged(TICKETING_HOLDS_MENU_ITEM);
                     } else if (activeTicketingMenuItem === TICKETING_HOLDS_MENU_ITEM) {
                        activeTicketingMenuItemChanged(TICKETING_KILLS_MENU_ITEM);
                     } else if (activeTicketingMenuItem === TICKETING_KILLS_MENU_ITEM) {
                       activeTicketingMenuItemChanged(TICKETING_PROMO_CODES_MENU_ITEM);
                     } else if (activeTicketingMenuItem === TICKETING_PROMO_CODES_MENU_ITEM) {
                       activeTicketingMenuItemChanged(TICKETING_DELIVERY_MENU_ITEM);
                     } else if (activeTicketingMenuItem === TICKETING_DELIVERY_MENU_ITEM) {
                        if (team.can_access_memberships) {
                          activeTicketingMenuItemChanged(TICKETING_MEMBERSHIPS_MENU_ITEM);
                        } else {
                          activeTicketingMenuItemChanged(TICKETING_SETTINGS_MENU_ITEM);
                        }
                     } else if (activeTicketingMenuItem === TICKETING_MEMBERSHIPS_MENU_ITEM) {
                        activeTicketingMenuItemChanged(TICKETING_SETTINGS_MENU_ITEM);
                     } else if (team.can_access_marketing_dashboard) {
                        activeMenuItemChanged(AUTOMATION_MENU_ITEM);
                     } else {
                       activeMenuItemChanged(PROMOTION_MENU_ITEM);
                     }
                   }
                 }
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      </div>
      {team.can_access_ticketing_setup_redesign ? (
        Object.keys(ticketTypeForForm).length > 0 ? (
          <TicketDrawer
            ticketTypeForForm={ticketTypeForForm}
            closeOnEsc={ticketDrawerClosesOnEsc}
            confirm={confirm}
            showActivities={showActivities}
            ticketTypes={ticketTypes}
            team={team}
            manualTaxes={manualTaxes}
            preSaleEnabled={preSaleEnabled}
            ticketTypeIsSeated={ticketTypeIsSeated}
            canSave={canSubmitForm(ticketTypeForForm, fairMarketValueEnabled)}
            renderPricePoints={enablePricePoints ? () => (
              <div className="ticket-type-drawer">
                <p className="ticket-drawer-block-title">Price changes</p>
                <TicketPricePoints
                  defaultTrigger="quantity"
                  ticketType={ticketTypeForForm}
                  onChange={(ticketType) => {
                    setOverCapacity(null);
                    ticketTypeForFormChanged(ticketType);
                  }}
                  onRecalculate={scheduleFinalCosts}
                  onAdd={newPricePoint}
                  onRemove={setPricePointToRemove}
                  minDate={pricePointsMinDate}
                  maxDate={pricePointsMaxDate}
                />
              </div>
            ) : undefined}
            onChange={(ticketType) => {
              setOverCapacity(null);
              ticketTypeForFormChanged(ticketType);
            }}
            onRecalculate={scheduleFinalCosts}
            onOpendateDistributionChange={(checked) => {
              if (checked && !team.agreed_to_opendate_distribution_terms_at && !distributionTermsAccepted) {
                setShowDistributionTermsModal(true);
                return;
              }
              ticketTypeForFormChanged(Object.assign({}, ticketTypeForForm, { opendate_distribution: checked }));
            }}
            onSave={(raiseCapacity) => {
              if (!canSubmitForm(ticketTypeForForm, fairMarketValueEnabled)) {
                return;
              }

              if (ticketTypeForForm.id) {
                updateTicketType(csrfToken, team, ticketTypeForForm, raiseCapacity);
              } else {
                createTicketType(csrfToken, team, confirm, ticketTypeForForm, raiseCapacity);
              }
            }}
            overCapacity={overCapacity}
            raisingCapacity={raisingCapacity}
            onKeepCapacity={() => setOverCapacity(null)}
            onCancel={() => ticketTypeForFormChanged({})}
            onClose={() => {
              ticketTypeForFormChanged({});
              exampleTicketChanged({});
            }}
          />
        ) : null
      ) : (
      <TicketTypeDrawer
        csrfToken={csrfToken}
        closeOnEsc={ticketDrawerClosesOnEsc}
        team={team}
        confirm={confirm}
        manualTaxes={manualTaxes}
        preSaleEnabled={preSaleEnabled}
        showActivities={showActivities}
        ticketTypes={ticketTypes}
        ticketTypeForForm={ticketTypeForForm}
        ticketTypeForFormChanged={(ticketType) => {
          setOverCapacity(null);
          ticketTypeForFormChanged(ticketType);
        }}
        ticketTypeIsSeated={ticketTypeIsSeated}
        exampleTicketChanged={exampleTicketChanged}
        overCapacity={overCapacity}
        raisingCapacity={raisingCapacity}
        onKeepCapacity={() => setOverCapacity(null)}
        createTicketType={createTicketType}
        updateTicketType={updateTicketType}
        distributionTermsAccepted={distributionTermsAccepted}
        enablePricePoints={enablePricePoints}
        newPricePoint={newPricePoint}
        pricePointsMaxDate={pricePointsMaxDate}
        pricePointsMinDate={pricePointsMinDate}
        setPricePointToRemove={setPricePointToRemove}
        setShowDistributionTermsModal={setShowDistributionTermsModal}
        startShowActivity={startShowActivity}
        useDateAndTime={useDateAndTime}
        useShowDetails={useShowDetails}
        onAfterOpen={() => scheduleFinalCosts(ticketTypeForForm)}
        debouncedDetermineFinalCosts={scheduleFinalCosts}
      />
      )}
      <OpendateDistributionTermsModal
        open={showDistributionTermsModal}
        agreeing={agreeingToTerms}
        onDecline={() => setShowDistributionTermsModal(false)}
        onAgree={() => {
          setAgreeingToTerms(true);
          axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
          axios.patch("/teams/" + team.id + "/agree_to_opendate_distribution_terms")
            .then(() => {
              setDistributionTermsAccepted(true);
              setShowDistributionTermsModal(false);
              var updated = Object.assign({}, ticketTypeForForm, {opendate_distribution: true});
              ticketTypeForFormChanged(updated);
            })
            .catch(() => {
              toastError("Failed to accept terms. Please try again.");
            })
            .finally(() => {
              setAgreeingToTerms(false);
            });
        }}
      />
      <SeatMapSwapPreviewModal
        preview={swapPreview}
        onClose={() => setSwapPreview(null)}
        onSwitch={() => {
          const { seating_chart: seatingChart } = swapPreview;
          setSwapPreview(null);
          saveSeatingChart(seatingChart, true);
        }}
      />
      <SeatMapSwapPricesModal
        seatingChart={seatingChartToSwapTo}
        onClose={() => setSeatingChartToSwapTo(null)}
        onConfirm={(keepPrices) => {
          const seatingChart = seatingChartToSwapTo;
          setSeatingChartToSwapTo(null);
          saveSeatingChart(seatingChart, keepPrices);
        }}
      />
      <Modal
        open={pricePointToRemove !== null}
        type="error"
        title="Remove price change"
        confirmLabel="Yes, remove price change"
        onClose={() => setPricePointToRemove(null)}
        onConfirm={() => {
          const updated = {
            ...pricePointToRemove,
            _destroy: true
          }

          ticketTypeForFormChanged({
            ...ticketTypeForForm,
            price_points: ticketTypeForForm.price_points.map(pp => pp.id === pricePointToRemove.id ? updated : pp)
          });

          setPricePointToRemove(null);
        }}
      >
        <div style={{"fontSize": "14px", "color": "var(--sl-text-secondary)"}}>
          {pricePointToRemove && !pricePointToRemove.newRecord ? (
            <p style={{"marginBottom": "22px"}}>
              This action will remove the price change, but this change will not be saved until you click the save button below.
            </p>
          ) : null}
          <p className="mb-0">
            Are you sure?
          </p>
        </div>
      </Modal>
    </React.Fragment>
  );
};

Tickets.propTypes = {
  seatingChartEventsChanged: PropTypes.func,
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  activeMenuItemChanged: PropTypes.func.isRequired,
  activeTicketingMenuItem: PropTypes.string,
  activeTicketingMenuItemChanged: PropTypes.func.isRequired,
  ticketTypeForForm: PropTypes.object,
  ticketTypeForFormChanged: PropTypes.func.isRequired,
  fetchNewTicketType: PropTypes.func.isRequired,
  ticketTypes: PropTypes.array,
  fetchTicketTypeForEdit: PropTypes.func.isRequired,
  addOns: PropTypes.array,
  addOnForForm: PropTypes.object,
  fetchNewAddOn: PropTypes.func.isRequired,
  addOnForFormChanged: PropTypes.func.isRequired,
  createAddOn: PropTypes.func.isRequired,
  fetchAddOnToEdit: PropTypes.func.isRequired,
  deleteAddOn: PropTypes.func.isRequired,
  updateAddOn: PropTypes.func.isRequired,
  addOnDragged: PropTypes.func.isRequired,
  exampleTicket: PropTypes.object,
  buildExampleTicket: PropTypes.func.isRequired,
  exampleTicketChanged: PropTypes.func.isRequired,
  seatingCharts: PropTypes.array,
  seatsIOPublicKey: PropTypes.string,
  autoSaveConfirm: PropTypes.func.isRequired,
  updateConfirm: PropTypes.func.isRequired,
  isLoadingDefaultTicketTypes: PropTypes.bool,
  addOnSeatingCharts: PropTypes.array,
  isEditingAddOnsIntro: PropTypes.bool,
  isEditingAddOnsIntroChanged: PropTypes.func.isRequired,
  addOnsIntroEditorState: PropTypes.object,
  addOnsIntroEditorStateChanged: PropTypes.func.isRequired,
  isLoadingDefaultAddOns: PropTypes.bool,
  isEditingAddOnsAlertMessage: PropTypes.bool,
  isEditingAddOnsAlertMessageChanged: PropTypes.func.isRequired,
  addOnsAlertMessageEditorState: PropTypes.object,
  addOnsAlertMessageEditorStateChanged: PropTypes.func.isRequired,
  showActivities: PropTypes.array.isRequired,
  manualTaxes: PropTypes.array,
  addOnAdded: PropTypes.func.isRequired,
  feeRuleSets: PropTypes.array,
  preSaleEnabled: PropTypes.bool,
  confirmChanged: PropTypes.func.isRequired,
  seatingChartEvents: PropTypes.array,
  rootTicketGroup: PropTypes.object.isRequired,
  ticketGroupChanged: PropTypes.func.isRequired,
  ticketTypesChanged: PropTypes.func.isRequired,
  isLoadingDefaultTicketTypesChanged: PropTypes.func.isRequired,
  ticketTypeIsSeated: PropTypes.func.isRequired,
  reloadTicketTypes: PropTypes.func.isRequired,
  reloadAddOns: PropTypes.func.isRequired,
  isLoadingDefaultAddOnsChanged: PropTypes.func.isRequired,
  holds: PropTypes.array,
  fetchHolds: PropTypes.func,
  createHold: PropTypes.func,
  updateHold: PropTypes.func,
  deleteHold: PropTypes.func,
  generalAdmissionHolds: PropTypes.array,
  fetchGeneralAdmissionHolds: PropTypes.func,
  createGeneralAdmissionHold: PropTypes.func,
  updateGeneralAdmissionHold: PropTypes.func,
  deleteGeneralAdmissionHold: PropTypes.func,
  kills: PropTypes.array,
  fetchKills: PropTypes.func.isRequired,
  createKill: PropTypes.func.isRequired,
  updateKill: PropTypes.func.isRequired,
  deleteKill: PropTypes.func.isRequired,
  addOnsIntroTemplates: PropTypes.array,
  addOnsAlertMessageTemplates: PropTypes.array,
  addOnsIntroTemplateDraft: PropTypes.object,
  addOnsAlertMessageTemplateDraft: PropTypes.object,
  addOnMessageTemplateChanged: PropTypes.func.isRequired,
  createAddOnMessageTemplate: PropTypes.func.isRequired,
  deleteAddOnMessageTemplate: PropTypes.func.isRequired
};

export default Tickets;

